const DownloadSmimeAttachmentEventName = 'DownloadSmimeAttachment';
export { DownloadSmimeAttachmentEventName };
